import { compose, lifecycle } from 'recompose';
import { connect } from 'react-redux';
import { hot } from 'react-hot-loader';

import { defaultAppData } from '../Shared/constants';
import { fetchJourneyMetadata, journeyBuilderStart } from '../Root/actions';
import { log } from '../Shared/UIEventLogger/UIEventLogger';
import api from '../Shared/Services/api';
import Root from './Root';

const mapStateToProps = state => {
  const { journeyBuilderUIDataArea, journeyBuilderConfigurationArea } = state;
  const isAppDataLoaded = window.App ? true : process.env.NODE_ENV === 'production'; // always assume the data is loaded in prod

  const journeyId = journeyBuilderConfigurationArea.interaction.id;
  const buId = journeyBuilderUIDataArea.userData.value.organization.id;

  return { isAppDataLoaded, journeyId, buId, journeyBuilderConfigurationArea };
};

const setAppDataLoaded = ({ isAppDataLoaded }) => loaded => ({
  isAppDataLoaded: loaded,
});

const mapDispatchToProps = {
  journeyBuilderStart,
  setAppDataLoaded,
  fetchJourneyMetadata,
};

export const enhance = lifecycle({
  componentDidMount() {
    const { isAppDataLoaded, setAppDataLoaded, journeyBuilderStart } = this.props;
    journeyBuilderStart();
    if (!isAppDataLoaded) {
      log(
        'App Data not loaded (front end running in node). Attempting to populate window.App via the API...'
      );
      api
        .getJson('/localization' + window.location.search) // pass along any query params (mainly for culture/ui-culture)
        .then(locInfo => {
          window.App = defaultAppData;
          window.App.localizationInfo = locInfo;
          if (Boolean(window.sessionStorage) && sessionStorage.getItem('developmentUserData')) {
            window.App.user = JSON.parse(sessionStorage.getItem('developmentUserData'));
          }
          log('App Data successfully loaded.');
          setAppDataLoaded(true);
        })
        .catch(error => {
          // ignore errors; the api may not be running on the dev server
          log(
            'App Data could not be loaded. Is the API running? You will not see localized translations. ',
            error
          );
        });
    }
  },
  componentDidUpdate(prevProps) {
    const { fetchJourneyMetadata, journeyId, buId } = this.props;
    if (
      prevProps.buId !== this.props.buId ||
      (prevProps.journeyId !== this.props.journeyId && buId)
    ) {
      fetchJourneyMetadata(journeyId, buId);
    }
  },
})(Root);

export default hot(module)(
  compose(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )
  )(enhance)
);



// WEBPACK FOOTER //
// ./src/Root/RootContainer.js